import { HttpClient } from '@angular/common/http';
import { TeamInfo } from '../entities';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class AppRootApiService {
    constructor(private http: HttpClient) {}

    getI18nData(locale: string, timestamp = new Date().getTime()) {
        return this.http.get(`/i18n/locales/${locale}.json?t=${timestamp}`);
    }

    getCurrentLoginUser() {
        return this.http.get(`/api/user/me`);
    }

    getTeam(): Observable<TeamInfo> {
        return this.http.get<TeamInfo>('/api/team');
    }

    getFollows() {
        return this.http.get('/api/follows');
    }

    getModulePreference() {
        return this.http.get('/api/user/module/preference');
    }
}
